
export default {
    pageTitle:{
      text:"Withdraw Application"
    },
    pageInfo:{
      text:"Please use the dropdown below to select a reason documenting your withdrawal request. Please note that submitting a withdrawal request will change the status of your application to Withdrawn or Certified-Withdrawn. An application in Withdrawn or Certified-Withdrawn status cannot be reinstated for further processing.",
      coloring: 'grey',
    },
    sections: [{
      fields: [
          {
              machine_name: 'case_note',
              widget: 'select',
              label: 'Withdraw Reason',
              selection: [
                "Position Filled by US Worker",
                "Worker Received Alternate Visa Status",
                "Significant Change in Duties",
                "Position No Longer Needed",
                "Other Valid Reason",
                "Employee Terminated",
                "Death of Workers",
                "Employee Left Company",
                "Secondary Employer",
                "Employer Changed Mind",
                "Worker Never Arrived"
            ],
            value: "- Select -",
            tooltip: `Select the Withdraw Reason of the Withdraw.`
          }
      ]
  
  }]}